import ScrubstrApiQueryService from '../ScrubstrApiQueryService/ScrubstrApiQueryService'
import { PageCustomizationDTO, PageCustomizationStatus } from '../../models/PageCustomization.model'

export class PageCustomizationsService {
  async getPageCustomizations(isAgency: boolean, status?: PageCustomizationStatus): Promise<PageCustomizationDTO[]> {
    const api = new ScrubstrApiQueryService()
    const params: Record<string, string> = {
      view: 'customizations',
      isAgency: String(isAgency),
    }
    if (status) params.status = status
    const response = await api.get<PageCustomizationDTO[]>({
      endpoint: 'admin/claim-pages/claimed-pages',
      params,
    })
    return response
  }

  async updatePageCustomizationStatus(id: number, status: 'approved' | 'rejected'): Promise<{ message: string }> {
    const api = new ScrubstrApiQueryService()
    const response = await api.post<{ message: string }>({
      endpoint: `admin/accept-claimed-page/${id}?action=customization`,
      data: { status },
    })
    return response
  }
}

export default PageCustomizationsService

